"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _isUndefined2 = _interopRequireDefault(require("lodash/isUndefined"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ThemeManager = _interopRequireDefault(require("../../../managers/ThemeManager"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * This Anchor component is used to highlight which anchor element the user
 * is currently on and lets the user scroll to a specific anchor element.
 */
var Anchor =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Anchor, _React$Component);

  function Anchor(props) {
    var _this;

    _classCallCheck(this, Anchor);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Anchor).call(this, props));

    _this.handleScroll = function (e) {
      var container = _this.props.container;
      var scrollPos;

      if (container === window) {
        scrollPos = window.scrollY;
      } else if (e && e.target && e.target.scrollTop) {
        scrollPos = e.target.scrollTop;
      } // Only set state if the last known scroll point does not match the current. This helps ensure
      // if the bottom of the page is hit, the correct anchor that was selected stays between async
      // update.


      var sameScroll = _this.handleScrollToTop && _this.handleScrollToTop === scrollPos;

      if (!sameScroll) {
        _this.setState({
          activeLink: _this.getCurrentAnchor(_this.props.offsetTop)
        });
      }

      _this.handleScrollToTop = false;
    };

    _this.handleScrollTo = function (linkId) {
      var target = document.getElementById(linkId);
      var _this$props = _this.props,
          container = _this$props.container,
          offsetTop = _this$props.offsetTop;

      _this.setState({
        activeLink: linkId
      }); // Check if target exists before trying to scroll


      if (target) {
        _this.handleScrollToTop = _this.scrollTo(container, _this.getOffsetTop(target) + offsetTop);
      }
    };

    _this.state = {
      activeLink: null
    };
    _this.links = [];
    return _this;
  }
  /**
   * Set properties we want child component to have access to
   * @returns {object} Properties child component will have access to
   */


  _createClass(Anchor, [{
    key: "getChildContext",
    value: function getChildContext() {
      var _this2 = this;

      return {
        anchor: {
          registerLink: function registerLink(linkId) {
            if (!_this2.links.includes(linkId)) {
              _this2.links.push(linkId);
            }
          },
          unregisterLink: function unregisterLink(linkId) {
            var index = _this2.links.indexOf(linkId);

            if (index !== -1) {
              _this2.links.splice(index, 1);
            }
          },
          activeLink: this.state.activeLink,
          scrollTo: this.handleScrollTo
        }
      };
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.addScrollEvent();
    }
    /**
     * If the container changed then re assign event listeners
     * @param {object} prevProps - previous props component received
     */

  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.container !== prevProps.container) {
        this.removeScrollEvent();
        this.addScrollEvent(this.props.container);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.removeScrollEvent();
    }
    /**
     * Add scroll event handler to container
     * @param {node} scrollContainer - scroll container
     */

  }, {
    key: "addScrollEvent",
    value: function addScrollEvent(scrollContainer) {
      var container = scrollContainer || this.props.container;

      if (container) {
        container.addEventListener('scroll', this.handleScroll);
        this.scrollEventContainer = container;
        this.handleScroll();
      }
    }
    /**
     * Remove scroll event
     */

  }, {
    key: "removeScrollEvent",
    value: function removeScrollEvent() {
      if (this.scrollEventContainer) {
        this.scrollEventContainer.removeEventListener('scroll', this.handleScroll, true);
        this.scrollEventContainer = null;
      }
    }
    /**
     * Event handler for scroll event
     * @param {event} e - event object
     */

  }, {
    key: "scrollTo",

    /**
     * Scroll container to a position
     * @param {node} container - node to scroll on
     * @param {number} position - position to scroll on container
     * @returns {number|false} scroll position of container
     */
    value: function scrollTo(container, position) {
      var scrollPos = false; // If the scroll point is lower than the container then grab the container scroll position
      // after scrolling.

      if (container === window) {
        window.scrollTo(0, position);
        scrollPos = window.scrollY; // Scroll container
      } else if (container && !(0, _isUndefined2.default)(container.scrollTop)) {
        container.scrollTop = position;
        scrollPos = container.scrollTop;
      }

      return scrollPos;
    }
    /**
     * Get offset top value of element relative to its container
     * @param {element} elem - Element to get offset top value of
     * @returns {number} Offset top value in pixels
     */

  }, {
    key: "getOffsetTop",
    value: function getOffsetTop(elem) {
      var elemRect = elem.getBoundingClientRect();

      if (elemRect.width || elemRect.height) {
        if (this.props.container && this.props.container.getBoundingClientRect) {
          return elem.offsetTop - this.props.container.offsetTop;
        }
      }

      return elem.offsetTop;
    }
    /**
     * Get the link id of the current section the user is in
     * @param {number} offsetTop - Number of pixels to offset by
     * @returns {string} Link id
     */

  }, {
    key: "getCurrentAnchor",
    value: function getCurrentAnchor(offsetTop) {
      var scrolledToElems = [];
      var container = this.props.container; // Get elements that user has scrolled passed

      this.links.forEach(function (linkId) {
        var target = document.getElementById(linkId); // Get Window based anchor

        if (target && container === window) {
          if (target.offsetTop + offsetTop <= window.scrollY) {
            var top = target.offsetTop + offsetTop;
            scrolledToElems.push({
              linkId: linkId,
              top: top
            });
          } // Get anchor based off element

        } else if (target && target.getBoundingClientRect && container && container.getBoundingClientRect && target.getBoundingClientRect().top + offsetTop <= container.getBoundingClientRect().top) {
          var _top = target.getBoundingClientRect().top + offsetTop;

          scrolledToElems.push({
            linkId: linkId,
            top: _top
          });
        }
      }); // Get last scrolled anchor

      if (scrolledToElems.length) {
        return this.getLastAnchor(scrolledToElems);
      } // Get first anchor if no anchors have been scrolled past


      return this.getFirstAnchor(this.links);
    }
    /**
     * Converts linkIds to objects with offset positions relative to
     * their container.
     * @param {array} linkIds - array of strings
     * @returns {array} anchor objects
     */

  }, {
    key: "convertLinkIdsToAnchors",
    value: function convertLinkIdsToAnchors(linkIds) {
      var _this3 = this;

      var anchors = [];
      linkIds.forEach(function (linkId) {
        var target = document.getElementById(linkId);

        if (target) {
          anchors.push({
            linkId: linkId,
            top: _this3.getOffsetTop(target)
          });
        }
      });
      return anchors;
    }
    /**
     * Get first anchor
     * @param {array} linkIds - array of strings
     * @returns {string} linkId
     */

  }, {
    key: "getFirstAnchor",
    value: function getFirstAnchor(linkIds) {
      // Get closest element to top of current viewport that user has already
      // scrolled passed
      var anchors = this.convertLinkIdsToAnchors(linkIds);

      if (anchors.length) {
        var maxSection = anchors.reduce(function (prev, curr) {
          return curr.top < prev.top ? curr : prev;
        });
        return maxSection.linkId;
      }

      return '';
    }
    /**
     * Get anchor furthest down from the users viewport
     * @param {array} anchors - anchors to scroll to
     * @returns {string} linkId
     */

  }, {
    key: "getLastAnchor",
    value: function getLastAnchor(anchors) {
      // Get closest element to top of current viewport that user has already
      // scrolled passed
      var maxSection = anchors.reduce(function (prev, curr) {
        return curr.top > prev.top ? curr : prev;
      });
      return maxSection.linkId;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          border = _this$props2.border,
          children = _this$props2.children,
          className = _this$props2.className,
          offsetTop = _this$props2.offsetTop,
          props = _objectWithoutProperties(_this$props2, ["border", "children", "className", "offsetTop"]);

      return _react.default.createElement("div", _extends({
        className: (0, _classnames.default)(className, "".concat(_ThemeManager.default.getVar('classPrefix'), "-anchor ").concat(_ThemeManager.default.getVar('classPrefix'))),
        "data-border": border
      }, props), children);
    }
  }]);

  return Anchor;
}(_react.default.Component);

exports.default = Anchor;
Anchor.childContextTypes = {
  anchor: _propTypes.default.object
};
Anchor.defaultProps = {
  border: true,
  container: window,
  offsetTop: 0
};
Anchor.propTypes = {
  /**
   * Whether or not to show anchor border
   */
  border: _propTypes.default.bool,

  /**
   * Content to be displayed
   */
  children: _propTypes.default.node,

  /**
   * className is used to add extra class for adding new style to override
   * default
   */
  className: _propTypes.default.string,

  /**
   * Pixels to offset from top when calculating position of scroll. Positive
   * number scrolls down further and negative scrolls up further.
   */
  offsetTop: _propTypes.default.number,

  /**
   * Container element to attach scroll event to. Pro tip: Always ensure the container exists
   * before setting it as a prop.
   */
  container: _propTypes.default.oneOfType([_propTypes.default.instanceOf(HTMLElement), _propTypes.default.instanceOf(Window)])
};